module.exports = __webpack_public_path__ + "img/sleeping.9ea4861a.gif";